import { NgModule } from '@angular/core';
import { UtilityLibComponent } from './utility-lib.component';

@NgModule({
  imports: [
  ],
  declarations: [UtilityLibComponent],
  exports: [UtilityLibComponent]
})
export class UtilityLibModule { }
